//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'Epworth',
  data() {
    return {
      defaultJson:{
        "Never": "从不",
        "Sitting quietly after lunch w\/o alcohol": "餐后静坐（未饮酒）",
        "Medical advice recommended": "建议咨询专业人士",
        "Lying down to rest in the afternoon": "午后躺下休息",
        "Moderate": "中度",
        "Normal": "正常",
        "Sitting inactive in a public place (e.g. a theater or a meeting)": "在公共场所（如剧院或会议中）独自就坐",
        "Sitting and reading": "坐着阅读时",
        "Sitting and talking to someone": "坐着并与某人谈话时",
        "Watching television": "看电视时",
        "High": "高度",
        "Evaluate the likeliness of dozing off in the following situations": "评估在下列情况打瞌睡的可能性：",
        "As car passenger for an hour": "作为乘客乘车 1 小时",
        "Stopped for a few minutes in traffic while driving": "停车几分钟后",
        "Slight": "轻度"
      },
      form:{
        seg1:'',
        seg2:'',
        seg3:'',
        seg4:'',
        seg5:'',
        seg6:'',
        seg7:'',
        seg8:'',
      },
      hasScore:false,
      disabled:false,
      dataList1:[
        {value:"0",name:'从不'},
        {value:"1",name:'轻度'},
        {value:"2",name:'中度'},
        {value:"3",name:'高度'},
      ],
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else { 
            form[key] = Number(form[key])
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return ''
      } else {
        // seg1 + seg2 + seg3 + seg4 + seg5 + seg6 + seg7 + seg8
        let result = form.seg1 + form.seg2 + form.seg3 + form.seg4 + form.seg5 + form.seg6 + form.seg7 + form.seg8
        self.hasScore = true
        return String(result)
      }
    }
  },
  
  
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Pulm/Epworth.vue